// GetRecommendationsForProduct returns a list of recommended products of the requested type
export const ProductRecommendationsPageService_GetRecommendationsPageLazy =
  () =>
    import("./service.grpc").then(
      (m) => m.ProductRecommendationsPageService_GetRecommendationsPage
    );
ProductRecommendationsPageService_GetRecommendationsPageLazy.method =
  "aysa_api.services.product_recommendations_page.v1.ProductRecommendationsPageService/GetRecommendationsPage" as const;
